import { default as angular } from "angular";
import uiRouter from "@uirouter/angularjs/lib-esm";

import { routeConfig } from "./routes";

import {
  vsName as ContactBookDetailComponentName,
  contactBookDetailComponentOptions,
} from "./views/info";


import { moduleName as recordsModuleName } from "../records";
import {
  ContactBookServiceProvider,
  vsProviderName as ContactBookServiceProviderName,
} from "./shared/ContactBookService";
import { vsModuleName as SharedContactBookModule } from "./shared"

export const vsName = "SlotTrak.ContactBook";

angular
  .module(vsName, [uiRouter,
    recordsModuleName,
    SharedContactBookModule]
  )
  .config(routeConfig)
  .provider(ContactBookServiceProviderName, ContactBookServiceProvider)
  
  .component(
    ContactBookDetailComponentName,
    contactBookDetailComponentOptions
  )
  
export default vsName; 
